export enum ScannerFlow {
  ATHENA = 'athena',
  ATHENA_PRACTICE = 'athenaPractice',
  ECW = 'ecw',
  EPIC = 'epic',
  GREENWAY = 'greenway',
  IMS = 'ims',
  MEDATIXX = 'medatixx',
  MEDENT = 'medent',
  MEDISOFTWARE = 'medisoftware',
  NO_SCANNER = 'no scanner',
  QUINCY = 'quincy',
  RPMS = 'rpms',
  SSN = 'ssn',
  T2MED = 't2med',
  TOMEDO = 'tomedo',
}
